import { useMemo, useState } from "react";
import {
  FiHome,
  FiPackage,
  FiBookmark,
  FiImage,
  FiLogOut,
  FiChevronLeft,
  FiChevronRight,
  FiBell,
  FiMenu,
  FiX,
  FiAlertCircle,
  FiStar,
} from "react-icons/fi";
import logo from "../assets/logo.png";
import DashboardHome from "../components/DashboardHome";
import PackageList from "./PackageList";
import BookingsManager from "../components/BookingsManager";
import MediaGallery from "../components/MediaGallery";
import UserManager from "../components/UserManager";
import SettingsPanel from "../components/SettingsPanel";
import ReportsDashboard from "../components/ReportsDashboard";
import ReviewsPanel from "../components/ReviewsPanel";
import { logout, getAdminInfo } from "../utils/auth";
import TaxiBookingsManager from "../components/TaxiBookingManagement";
import ManageTaxi from "../components/ManageTaxi";

const AdminDashboard = ({ blogPosts, setBlogPosts }) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeTab, setActiveTab] = useState("dashboard");
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);

  const adminInfo = getAdminInfo();
  const adminInitials = adminInfo?.name
    ? adminInfo.name
        .split(" ")
        .map((n) => n[0])
        .join("")
        .toUpperCase()
    : "AD";

  const navItems = useMemo(
    () => [
      {
        id: "dashboard",
        label: "Dashboard",
        icon: FiHome,
        description: "High-level overview and quick stats",
        action: () => setActiveTab("dashboard"),
      },
      {
        id: "packages",
        label: "Packages",
        icon: FiPackage,
        description: "Blueprint curated safari experiences",
        action: () => setActiveTab("packages"),
      },
      // {
      //   id: "availability",
      //   label: "Availability",
      //   icon: FiCalendar,
      //   description: "Inventory orchestration and calendars",
      //   action: () => setActiveTab("availability"),
      // },
      {
        id: "bookings",
        label: "Bookings",
        icon: FiBookmark,
        description: "Pipeline, approvals, guest dossiers",
        action: () => setActiveTab("bookings"),
      },
      {
        id: "taxiBookings",
        label: "Taxi Bookings",
        icon: FiBookmark,
        description: "Taxi bookings and management",
        action: () => setActiveTab("taxiBookings"),
      },
      {
        id: "manageTaxi",
        label: "Manage Taxi",
        icon: FiPackage,
        description: "Add and manage taxi vehicles",
        action: () => setActiveTab("manageTaxi"),
      },

      // {
      //   id: "blog",
      //   label: "Blogs",
      //   icon: FiFileText,
      //   description: "Editorial planning ",
      //   action: () => setActiveTab("blog"),
      // },
      {
        id: "media",
        label: "Media Vault",
        icon: FiImage,
        description: "Curate imagery, film, and assets",
        action: () => setActiveTab("media"),
      },
      {
        id: "reviews",
        label: "Reviews",
        icon: FiStar,
        description: "Manage customer reviews and testimonials",
        action: () => setActiveTab("reviews"),
      },
      // {
      //   id: "users",
      //   label: "Team Access",
      //   icon: FiUsers,
      //   description: "Roles, guides, and permissions",
      //   action: () => setActiveTab("users"),
      // },
      // {
      //   id: "reports",
      //   label: "Insights",
      //   icon: FiBarChart2,
      //   description: "Analytics, revenue, and KPIs",
      //   action: () => setActiveTab("reports"),
      // },
      // {
      //   id: "settings",
      //   label: "Stack Settings",
      //   icon: FiSettings,
      //   description: "Governance, integrations, billing",
      //   action: () => setActiveTab("settings"),
      // },
    ],
    []
  );

  const handleLogout = () => {
    setShowLogoutConfirm(true);
  };

  const confirmLogout = () => {
    setShowLogoutConfirm(false);
    logout();
  };

  const cancelLogout = () => {
    setShowLogoutConfirm(false);
  };

  return (
    <div className="ui-mdc-dashboard">
      <div className="ui-mdc-dashboard-noise" aria-hidden="true" />
      <aside
        className={`ui-mdc-dashboard-nav ${
          sidebarOpen ? "ui-mdc-dashboard-nav--open" : "ui-mdc-dashboard-nav--collapsed"
        }`}
      >
        <div className="ui-mdc-dashboard-brand">
          <div className="ui-mdc-dashboard-brand-logo">
            <img 
              src={logo} 
              alt="Yala Safari" 
              className={sidebarOpen ? "ui-mdc-dashboard-logo--full" : "ui-mdc-dashboard-logo--collapsed"}
            />
          </div>
          <button
            type="button"
            onClick={() => setSidebarOpen((prev) => !prev)}
            className="ui-mdc-dashboard-toggle"
            aria-label={sidebarOpen ? "Collapse navigation" : "Expand navigation"}
          >
            {sidebarOpen ? <FiChevronLeft /> : <FiChevronRight />}
          </button>
        </div>

     

        <nav className="ui-mdc-dashboard-menu">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;

            return (
              <button
                key={item.id}
                type="button"
                onClick={item.action}
                className={`ui-mdc-dashboard-link ${
                  isActive ? "ui-mdc-dashboard-link--active" : ""
                }`}
              >
                <span className="ui-mdc-dashboard-link-icon">
                  <Icon />
                </span>
                {sidebarOpen && (
                  <span className="ui-mdc-dashboard-link-body">
                    <span className="ui-mdc-dashboard-link-label">{item.label}</span>
             
                  </span>
                )}
              </button>
            );
          })}
        </nav>

        <div className="ui-mdc-dashboard-footer">
     
          <button
            onClick={handleLogout}
            type="button"
            className="ui-mdc-dashboard-logout"
          >
            <FiLogOut />
            {sidebarOpen && <span>Sign out</span>}
          </button>
        </div>
      </aside>

      {/* Mobile Overlay */}
      {sidebarOpen && (
        <div 
          className="ui-mdc-dashboard-overlay"
          onClick={() => setSidebarOpen(false)}
          aria-hidden="true"
        />
      )}

      <div className="ui-mdc-dashboard-main">
        <header className="ui-mdc-dashboard-header">
          <div className="ui-mdc-dashboard-header-left">
            <button
              type="button"
              onClick={() => setSidebarOpen((prev) => !prev)}
              className="ui-mdc-dashboard-mobile-toggle"
              aria-label="Toggle navigation"
            >
              {sidebarOpen ? <FiX /> : <FiMenu />}
            </button>
            <div>
              {/* <p className="ui-mdc-dashboard-kicker">Current module</p> */}
              <h2 className="ui-mdc-dashboard-heading">
                {navItems.find((item) => item.id === activeTab)?.label || "Dashboard"}
              </h2>
            </div>
          </div>

          <div className="ui-mdc-dashboard-actions">
            <div className="ui-mdc-dashboard-search">
              <span className="ui-mdc-dashboard-search-icon" aria-hidden="true">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="8" />
                  <line x1="21" y1="21" x2="16.65" y2="16.65" />
                </svg>
              </span>
              <input
                type="text"
                placeholder="Search across modules"
                className="ui-mdc-dashboard-search-input"
                aria-label="Search across modules"
              />
            </div>
            <button
              type="button"
              className="ui-mdc-dashboard-icon-button"
              aria-label="Notifications"
            >
              <FiBell />
            </button>
            <div className="ui-mdc-dashboard-profile">
              <div className="ui-mdc-dashboard-avatar">{adminInitials}</div>
              <div className="ui-mdc-dashboard-profile-meta">
                <p className="ui-mdc-dashboard-profile-name">
                  {adminInfo?.name || "Admin"}
                </p>
                <p className="ui-mdc-dashboard-profile-role">
                  {adminInfo?.role || "Super Administrator"}
                </p>
              </div>
            </div>
          </div>
        </header>

        {/* <section className="ui-mdc-dashboard-summary">
          <article className="ui-mdc-dashboard-card">
            <div className="ui-mdc-dashboard-card-header">
              <span className="ui-mdc-dashboard-card-label">Safari occupancy</span>
              <span className="ui-mdc-dashboard-card-badge">+8.5% vs LY</span>
            </div>
            <p className="ui-mdc-dashboard-card-metric">89%</p>
            <p className="ui-mdc-dashboard-card-subtext">
              Across all lodges · 14 active expeditions
            </p>
          </article>
          <article className="ui-mdc-dashboard-card">
            <div className="ui-mdc-dashboard-card-header">
              <span className="ui-mdc-dashboard-card-label">Pending approvals</span>
              <span className="ui-mdc-dashboard-card-badge ui-mdc-dashboard-card-badge--amber">
                Action required
              </span>
            </div>
            <p className="ui-mdc-dashboard-card-metric">12</p>
            <p className="ui-mdc-dashboard-card-subtext">
              Awaiting finance & safari lead sign-off
            </p>
          </article>
          <article className="ui-mdc-dashboard-card">
            <div className="ui-mdc-dashboard-card-header">
              <span className="ui-mdc-dashboard-card-label">Net revenue (MTD)</span>
              <span className="ui-mdc-dashboard-card-badge ui-mdc-dashboard-card-badge--success">
                Forecast aligned
              </span>
            </div>
            <p className="ui-mdc-dashboard-card-metric">$418K</p>
            <p className="ui-mdc-dashboard-card-subtext">
              Converted USD · excluding concession royalties
            </p>
          </article>
        </section> */}

        <main className="ui-mdc-dashboard-content">
          {activeTab === "dashboard" && <DashboardHome />}
          {activeTab === "packages" && <PackageList />}
          {/* {activeTab === "availability" && <AvailabilityCalendar />} */}
          {activeTab === "bookings" && <BookingsManager />}
          {activeTab === "manageTaxi" && <ManageTaxi />}
          {activeTab === "taxiBookings" && <TaxiBookingsManager />}
          {/* {activeTab === "blog" && (
            <BlogContentManager blogPosts={blogPosts} setBlogPosts={setBlogPosts} />
          )} */}
          {activeTab === "media" && <MediaGallery />}
          {activeTab === "users" && <UserManager />}
          {activeTab === "reports" && <ReportsDashboard />}
          {activeTab === "reviews" && <ReviewsPanel />}
          {activeTab === "settings" && <SettingsPanel />}
        </main>
      </div>

      {/* Logout Confirmation Modal */}
      {showLogoutConfirm && (
        <div className="ui-mdc-confirm-modal">
          <div className="ui-mdc-confirm-modal-content">
            <div className="ui-mdc-confirm-modal-header">
              <div className="ui-mdc-confirm-modal-icon">
                <FiAlertCircle />
              </div>
              <h3 className="ui-mdc-confirm-modal-title">Confirm Sign Out</h3>
            </div>
            <div className="ui-mdc-confirm-modal-body">
              <p className="ui-mdc-confirm-modal-message">
                Are you sure you want to sign out? You will need to log in again to access the dashboard.
              </p>
            </div>
            <div className="ui-mdc-confirm-modal-actions">
              <button
                type="button"
                onClick={cancelLogout}
                className="ui-mdc-confirm-button ui-mdc-confirm-button--secondary"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={confirmLogout}
                className="ui-mdc-confirm-button ui-mdc-confirm-button--danger"
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;